import React, { useEffect } from "react";
import { useModal } from "../../../context/ModalContext";
import { CloseIcon, PaymentOverdueIcon } from "../../../components/Icons";
import { StyledBookingFlowButton } from "../../containers/BookingScheduleContainer/BookingScheduleContainer.style";
import { MODALS } from "../../../config/params";
import { userActivityLogger } from "../../../utils/mixpanel";
import { MIXPANEL_EVENTS } from "../../../config/mixPanelEvents";

const GenericPaymentIssueModal = () => {
  const { openModal, closeModal } = useModal();

  useEffect(() => {
    userActivityLogger(MIXPANEL_EVENTS.DELINQUENCY_MODAL_SHOWN, {
      modal_type: "generic_payment_issue",
      delinquency_state: "payment_issue",
    });
  }, []);

  const handleContactHospital = () => {
    userActivityLogger(MIXPANEL_EVENTS.CONTACT_HOSPITAL_TRIGGERED, {
      referred_from: "generic_payment_issue_modal",
    });
    openModal(MODALS.OVERDUE_CONTACT_MODAL);
  };

  return (
    <div className="flex flex-col w-full xl:w-[24rem]">
      <div className="flex justify-end">
        <CloseIcon
          onClick={() => closeModal()}
          className="text-light-black cursor-pointer"
        />
      </div>
      <div className="w-full flex flex-col items-center gap-3">
        <div>
          <PaymentOverdueIcon width={72} height={72} />
        </div>
        <div className="text-xl font-semibold text-center w-80">
          Payment Issue
        </div>
        <div className="flex flex-col w-full">
          <div className="flex justify-center mb-4">
            <div className="text-center">
              There is an issue with your wellness plan payments.
              Please contact your hospital to resolve it before booking.
            </div>
          </div>
          <StyledBookingFlowButton
            disabled={false}
            fullWidth
            color="primary"
            className="!text-sm"
            size="small"
            onClick={handleContactHospital}
          >
            Contact Hospital
          </StyledBookingFlowButton>
        </div>
      </div>
    </div>
  );
};

export default GenericPaymentIssueModal;
